export default __webpack_public_path__ + "static/media/Search.03daacec.svg";